import { useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useApp } from '@/hooks/use-app-context';
import { collectionPlaceQueryOptions } from './collection-place.service';

export function useCookieGeolocationConsent() {
  const { user, setUser, language } = useApp();
  const queryClient = useQueryClient();
  const currentUserId = useRef(user?.id);
  currentUserId.current = user?.id;
  const lang = language === 'en' ? 'en' : 'fr';

  return async (decision: 'granted' | 'denied'): Promise<void> => {
    if (!user) return;
    const placeRequest = decision === 'granted'
      ? queryClient.fetchQuery(collectionPlaceQueryOptions(user.id, lang)).catch(() => null)
      : null;
    const consent = await collectionPlaceService.recordConsent(decision);
    if (currentUserId.current !== user.id) return;
    setUser({
      ...user,
      geolocationConsent: {
        decision: consent.geolocationConsent,
        version: consent.geolocationConsentVersion,
        at: consent.geolocationConsentAt,
      },
    });
    if (!placeRequest) return;
    await placeRequest;
  };
}
